import DT from 'duration-time-conversion';
import clamp from 'lodash/clamp';

export default class Sub {
    constructor(obj) {
        this.start = obj.start;
        this.end = obj.end;
        this.text = obj.text;
        this.text2 = obj.text2;
        this.Estart = obj.Estart;
        this.Eend = obj.Eend;
        this.Etext = obj.Etext;
        this.Etext2 = obj.Etext2;
        this.note = obj.note;
        this.bookmark = obj.bookmark;
    }

    get check() {
        return this.startTime >= 0 && this.endTime >= 0 && this.startTime < this.endTime;
    }

    get clone() {
        return new Sub(this);
    }

    get startTime() {
        try {
            return DT.t2d(this.start);
        } catch (e) {
            console.log(this);
            return DT.t2d(0);
        }
    }

    set startTime(time) {
        this.start = DT.d2t(clamp(time, 0, Infinity));
    }

    get endTime() {
        try {
            return DT.t2d(this.end);
        } catch (e) {
            console.log(this);
            return DT.t2d(0);
        }
    }

    set endTime(time) {
        this.end = DT.d2t(clamp(time, 0, Infinity));
    }

    get duration() {
        return parseFloat((this.endTime - this.startTime).toFixed(3));
    }

    get EstartTime() {
        try {
            return DT.t2d(this.Estart);
        } catch (e) {
            console.log(this);
            return DT.t2d(0);
        }
    }

    get EendTime() {
        try {
            return DT.t2d(this.Eend);
        } catch (e) {
            console.log(this);
            return DT.t2d(0);
        }
    }

    get Eduration() {
        if (this.Eend === '' || this.Estart === '' || this.Eend === undefined || this.Estart === undefined) {
            return 0;
        }

        if (this.EendTime < this.EstartTime) {
            return 0;
        }

        return parseFloat((this.EendTime - this.EstartTime).toFixed(3));
    }
}
